import { Component, OnInit } from '@angular/core';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { RequiredValidator, UntypedFormBuilder, Validators } from '@angular/forms';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { SolicitudDocumentosExViewModel, TDocumentoSolicitudExViewModel } from '../documentos/documentosEx.types';
import { TipoDocumentacionExViewModel } from '../../../_mantenimiento/general/tipodocumentacionex/tipodocumentacionex.types';
import { DocumentosExService } from '../documentos/documentosEx.service';
import { SolicitudExService } from '../datosbasicos/datosbasicosEx.service';
import { DatePipe } from '@angular/common';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { ActivatedRoute, Router } from '@angular/router';
import { EnumIdsTcEstadoCertificadoFitoEx, EnumIdsTcEstadoSolicitudEx, EnumIdsTcTipoSolicitudEx, EnumIdsTwTcSubTipoSolicitudEx } from '../types/enum';
import { EnumCodigosTwTcAcciones, EnumIdsTwTcTipoClonacion } from '../../../_importacion/solicitudes/types/enum';
import { GlobalService } from 'src/app/components/core/_infrastructure/classes/services/global.service';
import { UploadedFileViewModel } from 'src/app/components/core/components/uploader/document_uploader.types';
import { HttpParams } from '@angular/common/http';
import { ConfigurationService } from '../../../core/_infrastructure/classes/services/configuration.service';
import { Tc } from '../../../core/_infrastructure/types/common';

@Component({
    selector: 'app-documentosex-edit',
    templateUrl: './documentosEx-edit.component.html',
})
export class DocumentosExEditComponent extends ComponentBase implements OnInit {
    editMode = false;
    editTitle = 'Nuevo';

    listTipoDocumentacionEx: TipoDocumentacionExViewModel[];
    listTDocumentoSolicitudEx: TDocumentoSolicitudExViewModel[];
    listPais: Tc[];

    solicitudDocumentosEx: SolicitudDocumentosExViewModel;
    documento: TDocumentoSolicitudExViewModel;
    uploadedFile: UploadedFileViewModel = new UploadedFileViewModel();

    cols: any[];

    IdEstadoSolicitudEx: number;
    IdTipoSolicitudEx: number;
    TipoSolicitudExDescripcion: string;
    EstadoSolicitudExDescripcion: string;
    IdEstadoCertificadoFitoEx: number;
    EstadoCertificadoFitoExDescripcion: string;
    IdResultadoEnvioMuestrasLaboratorioEx: number | null;
    DescripcionIdResultadoEnvioMuestrasLaboratorioEx: string;
    IdSubTipoSolicitudEx: number | null;
    IdSubTipoSolicitudExDescripcion: string;
    EsCopiaCF: boolean;
    CodigoSolicitud: string;
    CodigoTipoSolicitud: string;
    tituloTipoSolicitud: string;
    EsEphyto: boolean;
    contador: number;
    labelPais = 'origen';

    tercerPaisConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_TERCER_PAIS_CON_ATEST_FITO;
    reExpConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_REEXPORTACION_CON_ATEST_FITO;
    canariasConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_CANARIAS_CON_ATEST_FITO;

    habilitarGuardar = true;
    habilitarVisibilidadSolicitante = true;
    requerirTexto: boolean | null = false;
    requerirFecha: boolean | null = false;
    requerirPais: boolean | null = false;
    documentoEphyto: number;

    visibilitySpinner = false;
    laHeGrabadoYo = false;
    esClonada = false;
    esGrabador = false;
    esReexportacion = false;
    megaSizeLimit = 0;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        public datepipe: DatePipe,
        private fb: UntypedFormBuilder,
        private navMenuService: NavMenuService,
        private solicitudExService: SolicitudExService,
        private globalService: GlobalService,
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private documentosExService: DocumentosExService,
        protected configService: ConfigurationService,
    ) {
        super(authService, notificationService, exceptionHandler, configService);

        this.solicitudDocumentosEx = new SolicitudDocumentosExViewModel();
        this.documento = new TDocumentoSolicitudExViewModel();
    }

    ngOnInit() {
        //hacemos el subscribe manual y no lo delegamos al async del HTML, volcamos a array de objetos para acceder al
        //valor de ciertas columnas al seleccionar un elemento
        this.documentosExService.getTipoDocumentacionEx().subscribe(res => {
            this.listTipoDocumentacionEx = res;
        });

        this.globalService.getAllPaisesExpor().subscribe(res => {
            this.listPais = res;
        });
        this.uploadedFile.OldGuidCollection = new Array<string>();
        this.createForm();

        let id = this.activatedRoute.snapshot.params['id'];
        let idDocumento = this.activatedRoute.snapshot.params['idDocumento'];

        this.guardRefreshPage(id);

        //Para saber si se actua como Inspector o Grabador
        let params = new HttpParams();
        params = params.append('idSolicitudEx', id.toString());
        params = params.append('idUsuario', this.loggedInUser!.Id.toString());

        this.solicitudExService.isSolicitudUsuario(params).subscribe(resultIsGrabada => {
            this.laHeGrabadoYo = resultIsGrabada;
            this.esGrabador = this.isGrabador && this.laHeGrabadoYo;

            if (idDocumento) {
                //EDICIÓN

                this.documentosExService.getDocumento(idDocumento).subscribe(result => {
                    this.documento = result;

                    this.tituloTipoSolicitud = this.documento.IdTipoSolicitudExDescripcion;
                    this.esClonada =
                        this.documento.TwSolicitudJerarquiaEx != null &&
                        this.documento.TwSolicitudJerarquiaEx.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION
                            ? true
                            : false;

                    //SI ES PREVIA
                    if (this.documento.EsPrevia) {
                        if (
                            this.documento.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_ACEPTADA &&
                            this.documento.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_PENDIENTE
                        ) {
                            this.tituloTipoSolicitud += '-Previa';
                        }
                    }

                    if (this.documento.IdTipoSolicitudEx === EnumIdsTcTipoSolicitudEx.ID_REEXPORTACION) {
                        this.esReexportacion = true;
                    }

                    this.IdTipoSolicitudEx = this.documento.IdTipoSolicitudEx;
                    this.CodigoSolicitud = this.documento.CodigoSolicitud;
                    this.CodigoTipoSolicitud = this.documento.CodigoTipoSolicitud;
                    this.IdEstadoSolicitudEx = this.documento.IdEstadoSolicitudEx;
                    this.IdEstadoCertificadoFitoEx = this.documento.IdEstadoCertificadoFitoEx;
                    this.TipoSolicitudExDescripcion = this.documento.IdTipoSolicitudExDescripcion;
                    this.EstadoSolicitudExDescripcion = this.documento.IdEstadoSolicitudExDescripcion;
                    this.EstadoCertificadoFitoExDescripcion = this.documento.IdEstadoCertificadoFitoExDescripcion;
                    this.IdResultadoEnvioMuestrasLaboratorioEx = this.documento.IdResultadoEnvioMuestrasLaboratorioEx;
                    this.DescripcionIdResultadoEnvioMuestrasLaboratorioEx = this.documento.DescripcionIdResultadoEnvioMuestrasLaboratorioEx;
                    this.IdSubTipoSolicitudEx = this.documento.IdSubTipoSolicitudEx;
                    this.IdSubTipoSolicitudExDescripcion = this.documento.IdSubTipoSolicitudExDescripcion;
                    this.EsCopiaCF = this.documento.IdCopia !== null && this.documento.IdCopia > 0;

                    this.uploadedFile = { ...this.uploadedFile, Guid: result.CodigoStorage, Name: result.NombreArchivo, Size: result.Size! };

                    this.updateForm();

                    //Si soy Inspector-Grabador
                    if (this.isGrabador && this.isInspector && this.documento.IdEstadoSolicitudEx == EnumIdsTcEstadoSolicitudEx.ID_REVISION_SOLICITANTE) {
                        this.habilitarGuardar =
                            this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_DOCUMENTOS_EXPORTACION, this.documento.IdEstadoSolicitudEx).Visible &&
                            this.laHeGrabadoYo;
                    } else {
                        //si el CF no está en estado PENDIENTE entonces es posible que haya documentos ya adjuntados al ePhyto y éste enviado a Traces, entonces envitar editar/eliminar documentos.
                        this.habilitarGuardar =
                            this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_DOCUMENTOS_EXPORTACION, this.documento.IdEstadoSolicitudEx).Visible &&
                            this.documento.IdEstadoCertificadoFitoEx == EnumIdsTcEstadoCertificadoFitoEx.ID_PENDIENTE &&
                            (!this.documento.SubidoPorInspector || this.isInspector);
                    }

                    this.habilitarVisibilidadSolicitante = this.habilitarGuardar && (this.documento.Perfil === 'Inspector' || this.esGrabador);

                    if (!this.habilitarGuardar) {
                        this.DisableControlsConsulta();
                    } else {
                        this.editMode = true;
                        this.editTitle = 'Editar';
                    }
                });
            } else {
                //ALTA

                this.documentosExService.getSolicitudDocumentos(id).subscribe(result => {
                    this.solicitudDocumentosEx = result;

                    this.tituloTipoSolicitud = this.solicitudDocumentosEx.IdTipoSolicitudExDescripcion;
                    this.esClonada =
                        this.solicitudDocumentosEx.TwSolicitudJerarquiaEx != null &&
                        this.solicitudDocumentosEx.TwSolicitudJerarquiaEx.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION
                            ? true
                            : false;

                    //SI ES PREVIA
                    if (this.solicitudDocumentosEx.EsPrevia) {
                        if (
                            this.solicitudDocumentosEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_ACEPTADA &&
                            this.solicitudDocumentosEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_PENDIENTE
                        ) {
                            this.tituloTipoSolicitud += '-Previa';
                        }
                    }

                    if (this.solicitudDocumentosEx.IdTipoSolicitudEx === EnumIdsTcTipoSolicitudEx.ID_REEXPORTACION) {
                        this.esReexportacion = true;
                    }

                    this.IdTipoSolicitudEx = this.solicitudDocumentosEx.IdTipoSolicitudEx;
                    this.CodigoSolicitud = this.solicitudDocumentosEx.CodigoSolicitud;
                    this.CodigoTipoSolicitud = this.solicitudDocumentosEx.CodigoTipoSolicitud;
                    this.IdEstadoSolicitudEx = this.solicitudDocumentosEx.IdEstadoSolicitudEx;
                    this.TipoSolicitudExDescripcion = this.solicitudDocumentosEx.IdTipoSolicitudExDescripcion;
                    this.EstadoSolicitudExDescripcion = this.solicitudDocumentosEx.IdEstadoSolicitudExDescripcion;
                    this.IdEstadoCertificadoFitoEx = this.solicitudDocumentosEx.IdEstadoCertificadoFitoEx;
                    this.EstadoCertificadoFitoExDescripcion = this.solicitudDocumentosEx.IdEstadoCertificadoFitoExDescripcion;
                    this.IdResultadoEnvioMuestrasLaboratorioEx = this.solicitudDocumentosEx.IdResultadoEnvioMuestrasLaboratorioEx;
                    this.DescripcionIdResultadoEnvioMuestrasLaboratorioEx = this.solicitudDocumentosEx.DescripcionIdResultadoEnvioMuestrasLaboratorioEx;
                    this.IdSubTipoSolicitudEx = this.solicitudDocumentosEx.IdSubTipoSolicitudEx;
                    this.IdSubTipoSolicitudExDescripcion = this.solicitudDocumentosEx.IdSubTipoSolicitudExDescripcion;
                });
            }

            this.MegaSizeLimitsCargado$.subscribe(() => {
                this.megaSizeLimit = this.getValorSizeLimit('documentosEx-edit');
            });
        });
    }

    get formInvalid(): boolean {
        return !this.form.valid || !this.form.dirty || this.form.pristine || !this.ficheroSubido;
    }

    get ficheroSubido(): boolean {
        return this.uploadedFile.Guid !== undefined && this.uploadedFile.Guid !== null && this.uploadedFile.Guid !== '' && !this.uploadedFile.MarkToDelete;
    }

    createForm() {
        this.form = this.fb.group({
            IdTipoDocumentacionEx: [null, Validators.required],
            Texto: '',
            Fecha: '',
            IdPais: null,
            NombreArchivo: ['', Validators.required],
            VisibleInspector: false,
        });
    }

    updateForm() {
        this.form.setValue({
            IdTipoDocumentacionEx: this.documento.IdTipoDocumentacionEx,
            Texto: this.documento.Texto,
            Fecha: this.documento.Fecha != null ? new Date(this.documento.Fecha) : null,
            IdPais: this.documento.IdPais,
            NombreArchivo: this.documento.NombreArchivo,
            VisibleInspector: !this.documento.VisibleInspector,
        });

        //pondrá como obligatorios los campos según el tipo de documentación cargado
        this.onSelectTipoDocumentacion();
    }

    private DisableControlsConsulta() {
        this.editTitle = 'Detalle';

        this.form.controls['IdTipoDocumentacionEx'].disable();
        this.form.controls['Texto'].disable();
        this.form.controls['Fecha'].disable();
        this.form.controls['IdPais'].disable();
        this.form.controls['NombreArchivo'].disable();
        this.form.controls['VisibleInspector'].disable();
    }

    guardRefreshPage(id: number) {
        if ((id && !this.navMenuService.currentSolicitudExportacion.Id) || this.navMenuService.currentSolicitudExportacion.Id !== id) {
            this.solicitudExService.getSolicitudEx(id).subscribe(result => {
                this.navMenuService.currentSolicitudExportacion = result;
            });
        }
    }

    onSelectTipoDocumentacion() {
        const idTipoDocumentoEx = this.form.value.IdTipoDocumentacionEx;

        let seleccionado = this.listTipoDocumentacionEx.find(x => x.Id == idTipoDocumentoEx);

        if (seleccionado != null) {
            this.requerirTexto = (<TipoDocumentacionExViewModel>seleccionado).RequerirTexto;
            this.requerirFecha = (<TipoDocumentacionExViewModel>seleccionado).RequerirFecha;
            this.requerirPais = (<TipoDocumentacionExViewModel>seleccionado).RequerirPais;

            if (this.requerirTexto!.valueOf() == true) {
                this.addValidator('Texto', Validators.required);
            } else {
                this.removeValidators('Texto');
            }

            if (this.requerirFecha!.valueOf() == true) {
                this.addValidator('Fecha', Validators.required);
            } else {
                this.removeValidators('Fecha');
            }

            if (this.requerirPais!.valueOf() == true) {
                this.addValidator('IdPais', Validators.required);
            } else {
                this.removeValidators('IdPais');
            }

            let certificadoFitosanitario = 6;
            if (seleccionado.Id === certificadoFitosanitario && !this.esReexportacion) {
                this.labelPais = 'destino';
            } else {
                this.labelPais = 'origen';
            }
        } else {
            this.labelPais = 'origen';
            this.requerirTexto = false;
            this.removeValidators('Texto');
            this.requerirFecha = false;
            this.removeValidators('Fecha');
            this.requerirPais = false;
            this.removeValidators('IdPais');
        }
    }

    onBack() {
        this.router.navigate(['/exportacion/solicitud/documentosEx', this.navMenuService.currentSolicitudExportacion.Id]);
    }

    onFileUploaded(uploadedFile: UploadedFileViewModel) {
        this.uploadedFile = uploadedFile;

        //en Uploader Local obtenemos el valor para este campo obligatorio en subida local
        this.form.controls['NombreArchivo'].setValue(this.uploadedFile!.Name);

        this.addSuccessMessage('Documento cargado. Recuerde GUARDAR antes de abandonar la pantalla');
    }

    onFileDeleted(deletedFile: UploadedFileViewModel) {
        this.uploadedFile = deletedFile;
    }

    onSubmit() {
        this.submitted = true;

        if (!this.form.valid) {
            this.addErrorMessage('Revise los datos del documento');
            return;
        }
        //Validamos si se ha cargado el documento:
        if (this.uploadedFile == null || this.uploadedFile.Name == null) {
            this.addErrorMessage('Debe cargar el documento antes de guardar');
            return;
        }

        this.visibilitySpinner = true;

        let documento = new TDocumentoSolicitudExViewModel();

        documento.IdTipoDocumentacionEx = this.form.value.IdTipoDocumentacionEx;

        documento.IdTipoDocumentacionEx = this.form.value.IdTipoDocumentacionEx;
        documento.IdPais = this.form.value.IdPais;
        documento.Fecha = this.form.value.Fecha;
        documento.Texto = this.form.value.Texto;
        documento.EsEphyto = this.form.value.EsPhyto;
        documento.SubidoPorInspector = this.isInspector ? true : false;

        //documento.VisibleInspector = this.esInspector ? !this.form.value.VisibleInspector : false;

        //documento.VisibleInspector = this.editMode ? documento.VisibleInspector :
        //    (!this.isInspector || (this.isGrabador && this.isInspector && this.laHeGrabadoYo)) ? false : true;
        documento.VisibleInspector = this.editMode
            ? !this.form.value.VisibleInspector
            : !this.isInspector || (this.isGrabador && this.isInspector && this.laHeGrabadoYo)
              ? false
              : !this.form.value.VisibleInspector;

        documento.IdSolicitudEx = this.navMenuService.currentSolicitudExportacion.Id;

        documento.Id = this.documento.Id;

        documento.NombreArchivo = this.uploadedFile.Name;
        documento.OldCodigoStorageCollection = this.uploadedFile.OldGuidCollection;
        documento.CodigoStorage = this.uploadedFile.Guid;
        documento.Size = this.uploadedFile.Size;
        documento.IdUsuario = this.loggedInUser!.Id;

        if (this.editMode) {
            this.documentosExService.editDocumento(documento).subscribe({
                next: () => {
                    this.addSuccessMessage('Documento modificado correctamente');
                    this.onBack();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        } else {
            this.documentosExService.createDocumento(documento).subscribe({
                next: () => {
                    this.addSuccessMessage('Documento añadido correctamente');
                    this.onBack();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        }
    }
}
